import { UserStar, X } from "lucide-react";
import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfessionalInfoForm from "../../ProfessionalInfoCollection/ProfessionalInfoForm";

const SAPNotEligibleModal = ({ onClose, notEligibleMessage }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <div className="fixed inset-0 flex items-center justify-center z-[1200] bg-black/50">
      <div className="bg-white mt-20 rounded-2xl shadow-lg max-w-xl w-full p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-[#572575] transition-colors"
        >
          <X size={22} />
        </button>

        <div className="flex justify-center mb-4">
          <div className="p-1 rounded-full">
            <img
              src="/PremiumAccess/MissingProfile.png"
              alt="square"
              className="h-16 w-auto"
            />
          </div>
        </div>

        <div className="font-inter font-bold text-[20px] text-[#8A40B5] text-center leading-none align-middle">
          Sorry, You Are Not Eligible !
        </div>

        <div className="font-inter mt-4 text-[#444444] text-sm font-normal leading-[16px] text-center mb-6">
          Based on the information you provided, you do not meet the eligibility
          criteria for this program.
        </div>

        <div className="flex items-center my-4 gap-3 bg-[#FDECEC] text-[#C32727] rounded-[12px] px-4 py-3 w-full">
          <div className="flex items-center justify-center w-6 h-6 bg-[#C32727] bg-opacity-10 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 text-[#C32727]"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M18 10A8 8 0 11 2 10a8 8 0 0116 0zm-8-4a1 1 0 00-.993.883L9 7v4a1 1 0 001.993.117L11 11V7a1 1 0 00-1-1zm0 8a1.25 1.25 0 100-2.5A1.25 1.25 0 0010 14z"
                clipRule="evenodd"
              />
            </svg>
          </div>

          <span className="font-inter text-sm leading-[20px]">
            {/* Your study gap of 1 year may not meet the program requirements. */}
            {notEligibleMessage}
          </span>
        </div>

        {/* {open && <ProfessionalInfoForm onClose={() => setOpen(false)} />} */}

        <div className="flex justify-center">
          <button
            onClick={() => window.location.reload()}
            // onClick={(prev) => prev + setOpen(true)}
            className="px-4 py-2 bg-[#572575] text-white rounded-lg font-altis font-bold text-[14px] leading-[14px] flex items-center gap-2 hover:bg-[#572575] transition"
          >
            <img
              src="/PremiumAccess/book.png"
              alt="explore"
              className="h-4 w-4"
            />
            Explore Other Courses
          </button>
        </div>
      </div>
    </div>
  );
};

export default SAPNotEligibleModal;
